import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../common/hooks/use-param-back-url';
import { selectSite } from '../../site/siteSlice';
import { ConnectionItem } from './components/ConnectionItem';
import { DeviceIcon } from './components/DeviceIcon';
import { HARDWARE_CONNECTION_TO_UI_CONFIG, HARDWARE_CONNECTIONS } from './constants';
import { HardwareConnectionType } from './types';
import { useDeviceSubtitle } from './use-device-subtitle';

export function HardwareConnection({ connectionType }: { connectionType: HardwareConnectionType }) {
  const { t } = useTranslation();
  const { deviceId } = useParams<{ deviceId: string }>();
  const backURL = useParamBackUrl(`../view?direction=back`);
  const { devices } = useSelector(selectSite);
  const { getSubtitle } = useDeviceSubtitle();
  const device = useMemo(() => devices.find((device) => device.id === Number(deviceId)), [devices, deviceId]);

  const { icon, title, subtitle, connection } = useMemo(() => {
    const connectionCurrent = HARDWARE_CONNECTIONS.find(({ type }) => type === connectionType);

    if (connectionType === 'ETHERNET') {
      return {
        ...HARDWARE_CONNECTION_TO_UI_CONFIG['ETHERNET'],
        subtitle: getSubtitle(device?.device_type, !!connectionCurrent?.enabled, 'ETHERNET'),
        connection: connectionCurrent,
      };
    }
    if (connectionType === 'WIFI') {
      return {
        ...HARDWARE_CONNECTION_TO_UI_CONFIG['WIFI'],
        subtitle: getSubtitle(device?.device_type, !!connectionCurrent?.enabled, 'WIFI'),
        connection: connectionCurrent,
      };
    }
    return { icon: undefined, title: undefined, subtitle: undefined, connection: undefined, connectionKey: undefined };
  }, [connectionType, device?.device_type, getSubtitle]);

  return (
    <SlidingAnimationPageBase title={t('Hardware.hardware')} backURL={backURL} pb={6}>
      <Box px={5}>
        <DeviceIcon Icon={icon} title={title} subtitle={subtitle} />
        <ConnectionItem connection={connection} />
      </Box>
    </SlidingAnimationPageBase>
  );
}
